import {Component, Input, OnInit} from '@angular/core';
import {Frequency} from '../model/frequency';

@Component({
  selector: 'gt-frequency-bars',
  templateUrl: './frequency-bars.component.html',
  styleUrls: ['./frequency-bars.component.css']
})

export class FrequencyBarsComponent implements OnInit {

  @Input() frequencyList: Frequency[];
  // @Input() ratingScore: number;
  // @Input() ratingText: string;
  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/frequency-bars.component.ts